export default "/assets/images/hero_mila2.webp?587c138d6d8b83311d34a46233cd6b7f";